import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import Modal from '../../../../../components/Modal';
import { backendErrorNotification, frontendNotification } from '../../../../../components/Notification';
import HttpStatus from '../../../../../enums/httpStatus';
import { accessBlocksApi } from '../../../../../services/requests';
import { AccessBlock } from '../../../../../types/apiResponse/accessBlock';

type Props = {
  showModal: boolean;
  selectedAccessBlock: AccessBlock;
  closeModal: () => void;
  callback: () => void;
};

const DeleteAccessBlockModal = ({
  showModal,
  selectedAccessBlock,
  closeModal,
  callback,
}: Props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const deleteRequest = async () => {
    setIsLoading(true);

    try {
      accessBlocksApi.query = '';
      const response = await accessBlocksApi.delete(selectedAccessBlock.id);
      if (response.status !== HttpStatus.OK) {
        throw response;
      }

      frontendNotification({ message: t('success') as string, type: 'success' });
      callback();
      closeModal();
    } catch (err) {
      if (!accessBlocksApi.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title={t('deleteAccessBlock') as string}
      showModal={showModal}
      closeModal={closeModal}
      cancelButton={closeModal}
      action={deleteRequest}
      isLoading={isLoading}
      bodyStyle={{
        paddingLeft: '1rem',
        paddingRight: '1rem',
        boxSizing: 'border-box',
      }}
    >
      <p>{t('deleteAccessBlockSure')}</p>
      <p>
        <strong>{t('description')}:</strong> {selectedAccessBlock.description}
      </p>
    </Modal>
  );
};

export default DeleteAccessBlockModal;
